// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1349":"5bb4877ae67c133a","2888":"8ae8bdba1856a49e","5309":"3d670102b6a53cab","8438":"bf3b217b7955ee0e"}[chunkId] + ".css";
};